import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // Fails loudly in dev rather than silently breaking auth later.
  // eslint-disable-next-line no-console
  console.error(
    'Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY. ' +
      'Add them to your .env file (see README-ADMIN-SETUP.md).'
  );
}

// IMPORTANT: this must always be the public "anon" key, never the
// service_role/secret key. The anon key is safe in the browser
// because Row Level Security on the database and storage does the
// actual access control.
export const supabase = createClient(supabaseUrl, supabaseAnonKey);
